import { render, staticRenderFns } from "./syncWechatCommunity.vue?vue&type=template&id=fb77ade4"
import script from "./syncWechatCommunity.vue?vue&type=script&lang=js"
export * from "./syncWechatCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports